export const getBSQuinoaPackage = newProduct => {
  const newBSQuinoaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSQuinoaPackage
}

export const updateBSQuinoaPackage = newProduct => {
  const newBSQuinoaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSQuinoaPackage
}
